module.exports = __webpack_public_path__ + "media/31.94eaf644.ogg";